import IntersectableComponent from './intersectable-component';


class Header extends IntersectableComponent {

	constructor({
		root,
		element,
		intersectingAttribute = 'section',
		intersectingColorSchemeAttribute = 'sectionColorScheme',
		threshold = 0,
		invertedClass = 'inverted',
		collapsedClass = 'collapsed',
		invertedValue = 'inverted'
	}) {
		super({
			root: root,
			element: element,
			intersectingAttribute: intersectingAttribute,
			intersectingColorSchemeAttribute: intersectingColorSchemeAttribute,
			threshold: threshold
		});
		this.invertedClass = invertedClass;
		this.collapsedClass = collapsedClass;
		this.invertedValue = invertedValue;
		this.wasInverted = null;
		this.onModalContext = false;
	}


	prepare() {
		super.prepare();
		const sections = this.root.querySelectorAll(this.dataSelector(this.intersectingAttribute));
		this.lastSection = (sections.length ? sections[sections.length - 1] : null);
		this.listeners.contextSwitch = this.events.on(this.root, 'context:beforeswitch', this.onContextSwitch.bind(this));
	}


	// overlays could have their own color scheme, so we change the header color and restore it afterwards, if needed
	onContextSwitch(event) {
		const newContext = event.detail.newContext;
		if (newContext.getName() !== 'default') {
			this.onModalContext = true;
			this.wasInverted = this.classList().contains(this.invertedClass);
			const newContextElement = newContext.getElement();
			if (this.dataAttr(newContextElement).has(this.intersectingColorSchemeAttribute)) {
				this.toggleIntersection(newContextElement);
			}
		} else {
			this.onModalContext = false;
			if (this.wasInverted !== null) {
				this.classList().toggle(this.invertedClass, this.wasInverted);
			}
		}
	}


	onIntersect(entries) {
		if (!this.onModalContext) {
			super.onIntersect(entries);
		}
	}



	toggleIntersection(intersectingElement) {
		this.classList().toggle(this.collapsedClass, intersectingElement === this.lastSection);
		const targetDataAttr = this.dataAttr(intersectingElement);
		const colorScheme = targetDataAttr.get(this.intersectingColorSchemeAttribute, '');
		this.classList().toggle(this.invertedClass, colorScheme === this.invertedValue);
	}

}

export default Header;
